import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import Box from "@mui/material/Box";
import { TableContainer } from "@mui/material";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setAuthToken } from "../../utils/setAuthToken";

// Generate Order Data
const dateFormatter = (date) => {
  console.log(date);
  const formattDate = new Date(date)
    .toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    })
    .replace(" at", "");
  return formattDate;
};

export default function TransactionTable() {
  const navigate = useNavigate();
  //backdrop usestates
  const [openbackdrop, setOpenbackdrop] = React.useState(false);
  const handleClose = () => {
    setOpenbackdrop(false);
  };
  const handleOpen = () => {
    setOpenbackdrop(true);
  };
  //Normal use states
  const [rows, setRows] = React.useState([]);
  const getAllTransaction = (e) => {
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .post("https://api.blockpay.co.za/blockchain/getAllTransaction", {})
      .then((res) => {
        console.log(res);

        setRows(res.data.data);
        console.log(rows);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };
  React.useEffect(() => {
    handleOpen();
    getAllTransaction();
    setTimeout(() => {
      handleClose();
    }, 2000);
  }, []);
  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openbackdrop}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ textAlign: "left", borderRadius: "6px" }}>
        <div
          sx={{ marginBottom: "16px", display: "flex", alignItems: "flex-end" }}
        >
          <Typography
            sx={{
              float: "left",
              fontSize: "1rem",
              lineHeight: "27px",
              fontWeight: 600,
              color: "black!important",
            }}
          >
            Transaction History
          </Typography>
        </div>
      </Box>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table size="medium">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                Order ID
              </TableCell>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                Date
              </TableCell>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                Type
              </TableCell>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                Total ETH
              </TableCell>
              <TableCell
                sx={{
                  color: "#666666",
                  fontWeight: 400,
                  fontSize: "1rem",
                  lineHeight: "27.2px",
                }}
              >
                Amount
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow sx={{ padding: "22px 14px" }} key={row.id}>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1.125rem",
                    lineHeight: "27.2px",
                  }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1.125rem",
                    lineHeight: "27.2px",
                  }}
                >
                  {dateFormatter(row.createdat)}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1.125rem",
                    lineHeight: "27.2px",
                  }}
                >
                  {row.type}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "none",
                    fontWeight: 500,
                    fontSize: "1.125rem",
                    lineHeight: "27.2px",
                  }}
                >
                  {row.status.toLowerCase() === "confirmed" ? (
                    <div style={{ color: "#15BA6D" }}>
                      {" "}
                      <CheckBoxIcon
                        sx={{ position: "relative", top: "0.25rem" }}
                      />{" "}
                      CONFIRMED
                    </div>
                  ) : row.status.toLowerCase() === "initiated" ? (
                    <div style={{ color: "#F7931A" }}>
                      {" "}
                      <IndeterminateCheckBoxIcon
                        sx={{ position: "relative", top: "0.25rem" }}
                      />{" "}
                      INITIATED
                    </div>
                  ) : row.status.toLowerCase() === "processing" ? (
                    <div style={{ color: "#F7931A" }}>
                      {" "}
                      <IndeterminateCheckBoxIcon
                        sx={{ position: "relative", top: "0.25rem" }}
                      />{" "}
                      PROCESSING
                    </div>
                  ) : (
                    <div style={{ color: "#E25C5C" }}>
                      {" "}
                      <DisabledByDefaultIcon
                        sx={{ position: "relative", top: "0.25rem" }}
                      />{" "}
                      DECLINED
                    </div>
                  )}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1.125rem",
                    lineHeight: "27.2px",
                  }}
                >
                  {`${row.amount} ETH`}
                </TableCell>
                <TableCell
                  style={{
                    borderBottom: "none",
                    color: "#111111",
                    fontWeight: 500,
                    fontSize: "1.125rem",
                    lineHeight: "27.2px",
                  }}
                >{`${row.amount} ETH`}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}
